define('navigation',['helpers', 'utils', 'navigation-validation', 'navigation-transition'], function(helpers, utils, Validation, Transition) {
    'use strict';

    var navigation;

    function Navigation(options) {
        options = options || {};

        this.swiping = options.swiping || {
            touchDevices: true,
            nonTouchDevices: false
        };

        this.validation = new Validation();

        this.transition = new Transition(options);

        this.viewModel = options.viewModel || {};

        if (this.swiping.touchDevices && utils.isTouchDevice || this.swiping.nonTouchDevices && !utils.isTouchDevice) {
            this.initSwipe();
        }
    }

    Navigation.prototype.initSwipe = function() {
        var _this = this;

        require(['hammer'], function(Hammer) {
            var timeoutID,
                player = document.getElementById('player'),
                content = document.getElementById('content'),
                layout = document.getElementById('js-layout-content'),
                props = {
                    recognizers: [
                        [Hammer.Swipe, {direction: Hammer.DIRECTION_HORIZONTAL}],
                    ]
                },
                managers = {
                    player: new Hammer.Manager(player, props),
                    content: new Hammer.Manager(content, props),
                    layout: new Hammer.Manager(layout, props),
                },
                swipe = function(e) {
                    var direction = e.direction || 0;

                    if (timeoutID) {
                        clearTimeout(timeoutID);
                    }

                    timeoutID = setTimeout(function() {
                        var body = document.body;

                        if (body.classList.contains('no-navigation-swipe')) {
                            return;
                        }

                        if (direction === 2) {
                            _this.navigateToDir('forward');
                        } else if (direction === 4) {
                            _this.navigateToDir('back');
                        }
                    }, 10);
                }

            managers.player.on('swipe', swipe);
            managers.content.on('swipe', swipe);
            managers.layout.on('swipe', swipe);
        });
    };

    Navigation.prototype.getTargetID = function(ID, target, dir) {
        return this.validation.getTargetID(ID, target, dir);
    };

    Navigation.prototype.setViewModel = function(viewModel) {
        this.viewModel = viewModel;
    }

    Navigation.prototype.completeLoading = function() {
        this.transition.completeLoading();
    }

    Navigation.prototype.navigateToDir = function(dir) {
        var ID = this.viewModel.entity.ID(),
            targetID = this.getTargetID(ID, null, dir);

        if (!targetID) {
            return;
        }

        this.viewModel.training.goTo(targetID, true, dir);
        // this.navigateTo(targetID); // - missing validation errors
    };

    Navigation.prototype.navigateTo = function(targetID, swiping, dir) {
        var _this = this;

        if (targetID === _this.viewModel.entity.ID()) {
            return;
        }

        this.transition.initLoading(swiping, dir, function() {
            _this.viewModel.updateVM(targetID)
        });
    };

    Navigation.prototype.validate = function(options) {
        options = options || {};

        return this.validation.validate(options);
    };

    return function(options) {

        if (!navigation) {
            navigation = new Navigation(options);
        }

        return navigation;

    };

});

